import { BrandMark, Diamond } from "./icons";
import type { Instrument } from "../api";

/**
 * Choose an assessment.
 *
 * Only shown when the embed doesn't already name one. Kim's Wix snippets carry
 * `?test=` per page, so in the normal funnel a visitor never sees this screen —
 * they land directly in the assessment that page is about. It exists for the
 * bare app URL, where offering the choice beats guessing.
 *
 * Deliberately no "recommended" badge and no default selection. These
 * instruments route to different places (readiness to Mastery Partners,
 * sellability toward a transaction), and nudging someone toward one before they
 * have answered anything is the tool making a judgement it has no basis for.
 */
export function Picker({
  instruments,
  onChoose,
  busy,
}: {
  instruments: Instrument[];
  onChoose: (slug: string) => void;
  busy: boolean;
}) {
  return (
    <>
      <BrandMark />
      <h1>Which assessment would you like to take?</h1>
      <p className="lede">
        Each one asks about your business in a different way. They take a few minutes, and every
        one ends with a scored summary by area.
      </p>

      <ul className="picker-list">
        {instruments.map((instrument) => (
          <li key={instrument.slug}>
            <button
              className="picker-option"
              onClick={() => onChoose(instrument.slug)}
              disabled={busy}
            >
              <span className="picker-label">{instrument.label}</span>
              <span className="picker-blurb">{instrument.blurb}</span>
              <span className="picker-meta">
                {instrument.total_questions} questions · {instrument.total_categories} areas scored
              </span>
            </button>
          </li>
        ))}
      </ul>

      <p className="gate-assure" style={{ border: 0, paddingTop: 14, marginTop: 14 }}>
        <span style={{ color: "var(--citron-ink)", flexShrink: 0, marginTop: 2 }}>
          <Diamond />
        </span>
        <span>
          No payment, no obligation. We ask for your email at the end so we can send the report.
        </span>
      </p>
    </>
  );
}
